import { AxiosResponse } from 'axios';

export function beforeResponse(res: AxiosResponse) {
  if (res.status === 401) {
    // TODO: refresh AT
    // store in session
    // Re-send query
  }
  return res;
}
